import { useState } from 'react'

import type { LANG } from '@eshop/type'

import i18n from './i18n'
import css from './index.module.css'

import { Input } from '#/global/component/Form/Input'

interface Props {
    lang: LANG
    unit: string
}

export const AddToCartSeason = ({ lang, unit }: Props) => {
    const [value, setValue] = useState(0)

    const handleChangeValue = (q: number) => {
        setValue(q)
    }

    const t = i18n[lang]
    return (
        <div className={`r-add-to-cart-season ${css.container}`}>
            <div className={css.input}>
                <Input onChange={handleChangeValue} type="number" value={value} />
                <span>{unit}</span>
            </div>
            <button className="dek-button dek-button-green" role="button" type="button">
                {t.order}
            </button>
        </div>
    )
}
